import { Input } from "@chakra-ui/react";
import { NotApplicable } from "./NotApplicable";

export const NumberField = ({
  value,
  required = false,
  step = 1,
  notApplicable = false,
  disabled = false,
  placeholder,
  onChange,
}: {
  value: number | null;
  required?: boolean;
  step?: number;
  notApplicable?: boolean;
  disabled?: boolean;
  placeholder?: number | string;
  onChange?: (value: number | null) => void;
}) => {
  return notApplicable ? (
    <NotApplicable />
  ) : (
    <Input
      size={"sm"}
      fontSize={"sm"}
      type="number"
      step={step}
      placeholder={placeholder != null ? `${placeholder}` : undefined}
      disabled={disabled}
      onChange={(e) => {
        const { value } = e.target;
        onChange?.(value === "" ? null : parseInt(value));
      }}
      min={0}
      value={value == null ? "" : value.toString()}
      borderColor={value == null && required ? "red.400" : undefined}
    />
  );
};
